// extracted by mini-css-extract-plugin
export default {"boxTeseo":"PaymentTeseo_boxTeseo__233Pg","pay_icon":"PaymentTeseo_pay_icon__Pu3fj","text_pay_icon":"PaymentTeseo_text_pay_icon__sZ36q"};